<template>
    <page-common :wrap-cls="['p-subject', 'hw-subject']" :on-line="onLine" :loading="loading" :is-exist="isExist" :reload="reload">
        <h2 class="title f-taj subject-title" v-if="subject.title">{{subject.title}}</h2>
        <div class="hd-img-wrap" v-else-if="subject.headImage">
            <div class="hd-img" :data-src="subject.headImage"></div>
        </div>
        <div class="info">
            <img class="icon" :src="require('common/image/logo_48.png')"
            /><span class="source">{{subject.source || '人民资讯'}}</span>
        </div>
        <!-- <div class="focus" v-if="normal.focus">
            <div class="swiper">
                <div
                    class="swiper-item"
                    v-for="(item, index) in normal.focus"
                    :key="index"
                    :data-index="index"
                >
                    <div class="img" :data-src="item.url"></div>
                </div>
            </div>
            <div class="bot-bar">
                <div class="title f-toe1">{{normal.focus[focusIndex] && normal.focus[focusIndex].text}}</div>
                <div class="num">
                    <span class="current">{{focusIndex + 1}}</span
                    ><span class="divider">/</span
                    ><span class="total">{{normal.focus.length}}</span>
                </div>
            </div>
        </div> -->
        <div class="focus">
            <div class="swiper">
                <div
                    class="swiper-item"
                >
                    <div class="img" :data-src="subject.headImage"></div>
                </div>
            </div>
            <!-- <div class="bot-bar">
                <div class="title f-toe1">{{normal.focus[focusIndex] && normal.focus[focusIndex].text}}</div>
                <div class="num">
                    <span class="current">{{focusIndex + 1}}</span
                    ><span class="divider">/</span
                    ><span class="total">{{normal.focus.length}}</span>
                </div>
            </div> -->
        </div>
        <div class="intro f-taj" v-if="subject.description">{{subject.description}}</div>
        <div class="nav-bar" v-if="subjectArticles && subjectArticles.length">
            <a
                class="nav-item"
                v-for="block in subjectArticles"
                v-if="block.articles && block.articles.length"
                :key="block.blockId"
                :data-block-id="block.blockId"
                @click="goBlock(block.blockId)">
                <div class="name">{{block.blockName}}</div>
            </a>
        </div>
        <div class="news-block" v-for="block in subjectArticles" v-if="block.articles && block.articles.length" :key="block.blockId" :data-block-id="block.blockId">
            <h4 class="block-title"><div class="title">{{block.blockName}}</div></h4>
            <news-item v-for="item in block.articles" :key="item.cardId" :item="item"></news-item>
        </div>
        <!-- <recommend-subject :item="recommendSubject"></recommend-subject> -->
    </page-common>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import Jt from 'common/util/jt';
import PageCommon from 'common/page/common';
import pageBaseMixin from 'common/mixin/page-base';
import Swiper from 'common/component/swiper/swiper.js';
import NewsItem from 'common/component/news-stream/news-item';
// import RecommendSubject from 'common/component/news-stream/recommend-subject';
import LazyLoadImg from 'common/component/lazy-load-img';
import 'hw/style/p-subject.less';

const Jt_B = Jt.base;
const Jt_D = Jt.dom;

export default {
    mixins: [pageBaseMixin],
    components: {
        PageCommon,
        NewsItem,
        // RecommendSubject
    },
    data() {
        return {
            focusIndex: 0,
            subject: {},
            subjectArticles: [],
            recommendSubject: {}
        };
    },
    computed: {
        ...mapGetters({
            scrollPos: 'app:scrollPos',
            onLine: 'subject:onLine',
            isExist: 'subject:isExist',
            loading: 'subject:loading',
            normal: 'subject:normal'
        })
    },
    watch: {
        'normal'(newValue) {
            this.subject = newValue.subject || {};
            // 资讯部的新闻与负一屏新闻采用不同的接口用该字段区分
            newValue.subjectArticles && newValue.subjectArticles.forEach((item) => {
                item.articles.forEach((item2) => {
                    item2.messageFrom = 'zxb';
                })
            })
            this.subjectArticles = newValue.subjectArticles || [];
            this.recommendSubject = newValue.hwCard || {};
            this.$nextTick(function() {
                this.lazyLoadImg.start();
            });
        },
        '$route'() {
            this.init({id: this.$route.params.id, messageFrom: this.$route.query.messageFrom});
        }
    },
    mounted() {
        this.initLazyLoadImg();
        this.renderFocus();
    },
    beforeDestroy() {
        this.destroyLazyLoadImg();
        this.destroyFocus();
    },
    methods: {
        ...mapActions({
            init: 'subject:init',
            reload: 'subject:reload',
        }),
        goBlock(id) {
            const block = this.$el.querySelector(`.news-block[data-block-id="${id}"]`);
            if(block) {
                const rect = block.getBoundingClientRect();
                Jt_D.scrollTo({x: 0, y: rect.top + Jt_D.getScrollPos().y, duration: 300});
            }
        },
        renderFocus(index = 0) {
            this.destroyFocus();
            this.focusSwiper = new Swiper({
                container: this.$el.querySelector('.swiper')
            }).on('swiped', (prev, index) => {
                this.focusIndex = index;
            });
        },
        destroyFocus() {
            this.focusSwiper && this.focusSwiper.destroy();
        }
    }
}

</script>
<style  lang="less" scoped>
    .subject-title {
        font-weight: bold;
    }
</style>




// WEBPACK FOOTER //
// src/hw/page/subject.vue